export enum PointConfigurationFunctionalityEnum {
  SUBTRACTS_PRODUCTIVITY = "SUBTRACTS_PRODUCTIVITY",
  CANCELS_PRODUCTIVITY = "CANCELS_PRODUCTIVITY",
  NO_EFFECT = "NO_EFFECT",
}
